import React from "react";
import { Box, Container, Typography, Button, useMediaQuery } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import Image from "../Images/UlapRecPictures/RecruitImg.png";

const useStyles = makeStyles((theme) => ({
    backgroundBox: {
        maxHeight: "100%",
        backgroundColor: theme.palette.primary.main, 
        color: theme.palette.primary.contrastText, 
        padding: theme.spacing(2.5), 
    },
    heroContainer: {
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        paddingTop: theme.spacing(12.5),
        paddingBottom: theme.spacing(12.5),
        flexDirection: "row",
        [theme.breakpoints.down("md")]: { 
            flexDirection: "column",
            paddingTop: theme.spacing(7.5),
            paddingBottom: theme.spacing(7.5),
        },
        [theme.breakpoints.down("sm")]: { 
            flexDirection: "column",
            paddingTop: theme.spacing(5),
            paddingBottom: theme.spacing(6.25),
        },
    },
    textContainer: {
        flex: 1,
        marginRight: theme.spacing(2.5),
        
        [theme.breakpoints.down("md")]: { 
            marginRight: 0,
            marginBottom: theme.spacing(2.5),
            textAlign: "center", 
        },
        [theme.breakpoints.down("sm")]: { 
            marginRight: 0,
            marginBottom: theme.spacing(2.5),
            textAlign: "left", 
        },
    },
    title: {
        // fontFamily: "Roboto", 
        fontSize: "50px",
        fontWeight: "bold",
        marginBottom: theme.spacing(1.25),
        [theme.breakpoints.down("md")]: { 
            fontSize: "40px",
        },
        [theme.breakpoints.down("sm")]: {
            fontSize: "30px",
        },
    },
    image: {
        flex: 1,
        maxWidth: "100%",
        height: "400px",
        [theme.breakpoints.down("md")]: { 
            maxWidth: "90%",
        },
        [theme.breakpoints.down("sm")]: {
            maxWidth: "100%",
        },
    },
    description: {
        // fontFamily: "Roboto", 
        fontSize: "20px",
        [theme.breakpoints.down("md")]: { 
            fontSize: "17px",
        },
        [theme.breakpoints.down("sm")]: { 
            textAlign: "justify",
            fontSize: "16px",
        },
    },
    button: {
        color: theme.palette.primary.contrastText,
        border: `1px solid ${theme.palette.primary.contrastText}`,
        marginTop: theme.spacing(2.5),
        marginRight: theme.spacing(1.25), 
        padding: theme.spacing(1.25, 2.5),
        textTransform: "none",
        borderRadius: "10px",
        [theme.breakpoints.down("md")]: {
            width: "30%",
        },
        [theme.breakpoints.down("sm")]: {
            width: "100%",
        },
    },
    whiteButton: {
        backgroundColor: "#FFFFFF", 
        color: "#FF7707",
        marginTop: theme.spacing(2.5),
        marginRight: theme.spacing(1.25),
        padding: theme.spacing(1.25, 2.5),
        textTransform: "none",
        borderRadius: "10px",
        cursor: "pointer", 
        "&:hover": {
            backgroundColor: "#FFFFFF", 
        },
        [theme.breakpoints.down("md")]: {
            width: "30%",
        },
        [theme.breakpoints.down("sm")]: {
            width: "100%",
        },
    },
}));

function HeroPage() {
    const classes = useStyles();

    return (
        <Box className={classes.backgroundBox}>
            <Container className={classes.heroContainer}>
                <Box className={classes.textContainer}>
                    <Typography className={classes.title}>Hire Right Candidates with Right Jobs</Typography>
                    <Typography className={classes.description}>
                        Go beyond just hiring and start strategically aligning your talent priorities. 
                        Every hire should be a step toward your future, and we can ensure each one moves you forward.
                    </Typography>
                    <Button className={classes.whiteButton}>Get A Demo</Button>
                    <Button className={classes.button} style={{ marginRight: 0 }}>Post A Job</Button> 
                </Box>
                <img src={Image} alt="Image" className={classes.image} />
            </Container>
        </Box>
    );
}

export default HeroPage;
